import { FC } from 'react'

import { useUnit } from 'effector-react'

import { Button } from '@/components/ui/button'
import { Tooltip } from '@/components/ui/tooltip'
import {
  $areSuggestionsTranslated,
  $suggestionsTranslatedLanguage,
  translateSuggestionsFx,
} from '@/models/chattingUI/chatSuggestions/chatSuggestions.ts'
import { $fanId } from '@/models/chattingUI/chats/chats.ts'
import {
  $chatterLanguage,
  $isTranslatorEnabled,
} from '@/models/chattingUI/messages/translations.ts'

import TranslationIcon from '../../../icons/action-ai-translation.svg'
import RefreshIcon from '../../../icons/regenerate.svg'
import { IconButton } from '../../components/icon-button'

interface Props {
  onRegenerate: () => void
}

export const ChatSuggestionsHeaderActions: FC<Props> = ({ onRegenerate }) => {
  const chatterLanguage = useUnit($chatterLanguage)
  const isTranslatorEnabled = useUnit($isTranslatorEnabled)
  const areSuggestionsTranslated = useUnit($areSuggestionsTranslated)
  const suggestionsTranslatedLanguage = useUnit($suggestionsTranslatedLanguage)
  const isTranslating = useUnit(translateSuggestionsFx.pending)
  const fanId = useUnit($fanId)

  const needsTranslation =
    chatterLanguage && chatterLanguage !== suggestionsTranslatedLanguage

  const handleTranslate = () => {
    if (fanId) {
      translateSuggestionsFx(fanId)
    }
  }

  return (
    <div className="ml-auto flex items-center gap-2">
      {areSuggestionsTranslated &&
        suggestionsTranslatedLanguage &&
        !needsTranslation && (
          <span className="text-primary-500 font-medium mr-4 select-none">
            Translated to &#34;
            {suggestionsTranslatedLanguage?.slice(0, 2).toUpperCase()}&#34; by
            AI Chatting
          </span>
        )}

      {!isTranslating && needsTranslation && (
        <Tooltip
          content={!isTranslatorEnabled ? 'AI Translator is not active' : ''}
        >
          <Button
            onClick={handleTranslate}
            variant="outline"
            className="text-md m-1 border-2 rounded p-2"
            disabled={!isTranslatorEnabled}
          >
            <TranslationIcon /> Translate AI Suggestions
          </Button>
        </Tooltip>
      )}

      <IconButton
        icon={RefreshIcon}
        onClick={onRegenerate}
        tooltip="Regenerate suggestions"
        iconClassName="h-4 w-4 text-md m-1"
      />
    </div>
  )
}
